import React from 'react'
import PropTypes from 'prop-types'

const MsgIntro = props => {
  return (
    <div className={'msg-intro ' + (props.outbid ? 'outbid' : '')}>
      {props.children}
    </div>
  )
}

MsgIntro.propTypes = {
  outbid: PropTypes.bool
}

export default MsgIntro



// WEBPACK FOOTER //
// ./src/ui/messages/msg-intro.js